<form [formGroup]="form" (ngSubmit)="createConversation()">
	<header mat-dialog-title>
		<mat-icon class="dialog-icon">edit</mat-icon>
		<span>New conversation</span>
	</header>

	<section mat-dialog-content>
		<div class="type-selector">
			<button
				type="button"
				class="type-btn"
				[class.selected]="selectedType === 'BROADCAST'"
				(click)="form.get('type')!.setValue('BROADCAST')"
			>
				<mat-icon>campaign</mat-icon>
				<span>Broadcast</span>
			</button>
			<button
				type="button"
				class="type-btn"
				[class.selected]="selectedType === 'DIRECT'"
				(click)="form.get('type')!.setValue('DIRECT')"
			>
				<mat-icon>person</mat-icon>
				<span>Direct</span>
			</button>
		</div>

		@if (devices().length > 0) {
			<mat-form-field appearance="outline">
				<mat-label>{{ isDirectConversation ? 'Device' : 'Devices (optional)' }}</mat-label>
				<mat-select formControlName="deviceIds" [multiple]="!isDirectConversation">
					@for (device of devices(); track device.id) {
						<mat-option [value]="device.id">{{ device.displayName }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}

		<mat-form-field appearance="outline">
			<mat-label>Message</mat-label>
			<textarea
				matInput
				formControlName="message"
				placeholder="Write your message..."
				rows="3"
			></textarea>
		</mat-form-field>
	</section>

	<footer mat-dialog-actions align="end">
		<button type="button" mat-button mat-dialog-close [disabled]="isSubmitting()">
			Cancel
		</button>
		<button type="submit" mat-flat-button color="primary" [disabled]="form.invalid || isSubmitting()">
			@if (isSubmitting()) {
				<mat-spinner diameter="16" />
			} @else {
				Send
			}
		</button>
	</footer>
</form>
